import CityPageTemplate from "../city-template/CityPageTemplate";
import { lexingtonConfig } from "./data";

export default function LexingtonPage() {
  return <CityPageTemplate config={lexingtonConfig} />;
}